<ion-grid [fixed]="true">
  <ion-row>
    <ion-col size="12" size-md="5">
      <ion-radio-group [(ngModel)]="selectedPaperColorType">
        <ion-text color="primary">
          <h3>{{ "PRINT.COLOR.DESCRIPTION" | translate }}</h3>
        </ion-text>
        <app-option-selector
          [nameString]="'PRINT.COLOR.BLACK' | translate"
          [item]="paperColorType.BlackWhite"
          [isSelected]="selectedPaperColorType() == paperColorType.BlackWhite"
          (click)="onPaperColorTypeClick(paperColorType.BlackWhite)"
          (dblclick)="onDoubleClick()">
        </app-option-selector>
        <app-option-selector
          [nameString]="'PRINT.COLOR.COLORED' | translate"
          [item]="paperColorType.Colored"
          [isSelected]="selectedPaperColorType() == paperColorType.Colored"
          (click)="onPaperColorTypeClick(paperColorType.Colored)"
          (dblclick)="onDoubleClick()">
        </app-option-selector>
      </ion-radio-group>
    </ion-col>
    @if(shouldShowPaperColorSide()) {

    <ion-col size="12" size-md="5" push-md="1">
      <ion-radio-group [(ngModel)]="selectedPaperSideType">
        <ion-text color="primary">
          <h3>{{ "PRINT.SIDE.DESCRIPTION" | translate }}</h3>
        </ion-text>
        <app-option-selector
          [nameString]="'PRINT.SIDE.SINGLE' | translate"
          [item]="paperSideType.SingleSided"
          [isSelected]="selectedPaperSideType() == paperSideType.SingleSided"
          (click)="onPaperSideClick(paperSideType.SingleSided)"
          (dblclick)="onDoubleClick()">
        </app-option-selector>
        <app-option-selector
          [nameString]="'PRINT.SIDE.DOUBLE' | translate"
          [item]="paperSideType.DoubleSided"
          [isSelected]="selectedPaperSideType() == paperSideType.DoubleSided"
          (click)="onPaperSideClick(paperSideType.DoubleSided)"
          (dblclick)="onDoubleClick()">
        </app-option-selector>
      </ion-radio-group>
    </ion-col>
    }
  </ion-row>
</ion-grid>
